import React from "react";
import styles from "./Tabs.scss"; 

const Tabs = ({ tabs, onTabChange, activeId }) => {
    return (
        <div className={styles.tabs}>
            {tabs.map((tab, index) => {
                const isActive = tab.providerId === activeId;
                const content = tab.image ? (
                    <img
                        src={tab.image}
                        alt={tab.label}
                        className={`${styles.tabIcon} ${
                            isActive ? styles.active : styles.inactive
                        }`}
                    />
                ) : (
                    <span
                        className={`${styles.tabLabel} ${
                            isActive ? styles.active : ""
                        }`}
                    >
                        {tab.label}
                    </span>
                );

                return (
                    <div
                        key={tab.providerId || index}
                        className={`${styles.tab} ${isActive ? styles.active : ""}`}
                        onClick={() => onTabChange(tab)}
                    >
                        {content}
                    </div>
                );
            })}
        </div>
    );
};

export default Tabs;